import React from "react";
import Stack from "@vapor/react-material/Stack";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import ExtendedTabs from "@vapor/react-extended/ExtendedTabs";
import ExtendedTab from "@vapor/react-extended/ExtendedTab";
import { DataGridPro, GridToolbar, itIT } from "@mui/x-data-grid-pro";
import { NoData } from "../../../../components/NoData";

export const ImportSelectionPanel = ({
  t,
  activeTab,
  onTabChange,
  importableColumns,
  importableRows,
  existingColumns,
  existingRows,
  selectedRowIds,
  onSelectionChange,
}) => {
  return (
    <Stack direction="column" spacing={1} sx={{ width: "70%" }}>
      <ExtendedTypography variant="titleSmall" color="primary.main">
        {t("anagrafica.ImportDesktop.selFiles")}
      </ExtendedTypography>

      <ExtendedTabs
        variant="standard"
        size="small"
        value={activeTab}
        onChange={onTabChange}
        sx={{ mb: 2 }}
      >
        <ExtendedTab value="tabImportabili" label="Disponibili" />
        <ExtendedTab value="tabNonDisponibili" label="Fascicoli già presenti" />
      </ExtendedTabs>

      {activeTab === "tabImportabili" ? (
        <Stack direction="column" spacing={0} justifyContent="left" alignItems="left">
          {importableColumns.length > 0 && importableRows.length > 0 ? (
            <DataGridPro
              rows={importableRows}
              columns={importableColumns}
              slots={{ toolbar: GridToolbar }}
              autoHeight={true}
              pageSizeOptions={[25, 50, 100]}
              localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
              pagination
              disableSelectionOnClick
              checkboxSelection
              rowSelectionModel={selectedRowIds}
              isRowSelectable={(params) => params.row.isComplete && params.row.legaleRappStatus !== "yellow"}
              onRowSelectionModelChange={(id) => {
                onSelectionChange(id);
              }}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    id: false,
                  },
                },
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
            />
          ) : (
            <NoData />
          )}
        </Stack>
      ) : null}

      {activeTab === "tabNonDisponibili" ? (
        <Stack direction="column" spacing={0} justifyContent="left" alignItems="left">
          {existingRows.length > 0 ? (
            <DataGridPro
              rows={existingRows}
              columns={existingColumns}
              slots={{ toolbar: GridToolbar }}
              autoHeight={true}
              pageSizeOptions={[25, 50, 100]}
              localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
              pagination
              disableRowSelectionOnClick
              getRowId={(row) => row.fascicoloId}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    fascicoloId: false,
                  },
                },
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
            />
          ) : (
            <NoData />
          )}
        </Stack>
      ) : null}
    </Stack>
  );
};
